module.exports = __webpack_public_path__ + "img/img-01.74e73ac8.png";